import React, { useMemo } from 'react';
import BaseCrossFlowProvider from '@atlassiansox/cross-flow-support/confluence';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { getUsersPlugin, getContainersPlugin } from './utils/index.ts';

export const CrossFlowProvider = ({ children }: { children: any }): any => {
	const { cloudId, locale } = useSessionData();
	const analyticWebClient = useMemo(() => getAnalyticsWebClient(), []);
	const isMarketingOptOut =
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') ===
		'true';

	if (isMarketingOptOut) {
		return children;
	}

	return (
		<BaseCrossFlowProvider
			cloudId={cloudId}
			analyticsClient={analyticWebClient}
			locale={locale}
			plugins={[getUsersPlugin, getContainersPlugin]}
		>
			{children}
		</BaseCrossFlowProvider>
	);
};
